// extracted by mini-css-extract-plugin
module.exports = {"price":"rW-z","onSale":"sW-z"};